import tradeIn from 'shared/assets/images/service-trade-in.svg';
import testDrive from 'shared/assets/images/service-wheel.svg';
import accessories from 'shared/assets/images/service-accessories.svg';
import credit from 'shared/assets/images/service-credit.svg';
import insurance from 'shared/assets/images/service-insurance.svg';

const servicesObjects = {
  trade_in: {
    title: 'Trade-in',
    icon: tradeIn,
    description:
      'Данный автосалон предоставляет возможность обменять своё старое авто на новое из своего модельного ряда',
  },
  test_drive: {
    title: 'Тест-драйв',
    icon: testDrive,
    description: 'Доступно для тест-драйва 1 авто',
  },
  insurance: {
    title: 'Страховка',
    icon: insurance,
    description: 'Данный автосалон предоставляет возможность застраховать Ваше авто',
  },
  accessories: {
    title: 'Аксессуары',
    icon: accessories,
    description:
      'Данный автосалон предоставляет возможность приобрести фирменные аксессуары для авто',
  },
  credit: {
    title: 'Кредит',
    icon: credit,
    description:
      'Данный автосалон предоставляет возможность приобрести авто из своего модельного ряда в кредит',
  },
};

export default servicesObjects;



// WEBPACK FOOTER //
// ./src/shared/constants/services.js